import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function exportarAuditoriaPDF(lista) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Auditoria de Comandos</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Auditoria de Comandos</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — ${lista.length} comando${lista.length !== 1 ? 's' : ''} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Data/Hora</th><th>Veículo</th><th>Ação</th><th>Usuário</th><th>IP</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${lista.map(c => `
            <tr>
              <td>${c.criado_em ? new Date(c.criado_em).toLocaleString('pt-BR') : '—'}</td>
              <td>${c.target_identificador || '—'} ${c.target_nome ? '— ' + c.target_nome : ''}</td>
              <td>${c.tipo === 'BLOQUEAR' ? 'Bloquear' : 'Desbloquear'}</td>
              <td>${c.usuario_nome || '—'} ${c.usuario_email ? '— ' + c.usuario_email : ''}</td>
              <td>${c.ip || '—'}</td>
              <td>${c.status === 'enviado' ? 'Enviado' : 'Pendente'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarAuditoriaCSV(lista) {
  const linhas = [
    'Data/Hora,Veículo,Ação,Usuário,Email,IP,Status',
    ...lista.map(c => {
      const campos = [
        c.criado_em ? new Date(c.criado_em).toLocaleString('pt-BR') : '',
        [c.target_identificador, c.target_nome].filter(Boolean).join(' - '),
        c.tipo === 'BLOQUEAR' ? 'Bloquear' : 'Desbloquear',
        c.usuario_nome,
        c.usuario_email,
        c.ip,
        c.status === 'enviado' ? 'Enviado' : 'Pendente'
      ];
      return campos.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(',');
    })
  ];
  const blob = new Blob([String.fromCharCode(0xFEFF) + linhas.join(String.fromCharCode(10))], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `auditoria_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
}

function Auditoria() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [comandos, setComandos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState('');
  const [tipo, setTipo] = useState('');
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarComandos(); }, [tipo, inicio, fim]);

  const carregarComandos = async () => {
    setCarregando(true);
    try {
      const params = {};
      if (tipo) params.tipo = tipo;
      if (inicio) params.inicio = inicio;
      if (fim) params.fim = fim;
      const res = await axios.get(`${API}/auditoria/comandos`, { headers, params });
      setComandos(res.data);
    } catch (err) { console.error(err); }
    setCarregando(false);
  };

  const buscaLower = busca.toLowerCase().trim();
  const comandosFiltrados = buscaLower === '' ? comandos : comandos.filter(c => {
    return (
      (c.target_identificador || '').toLowerCase().includes(buscaLower) ||
      (c.target_nome || '').toLowerCase().includes(buscaLower) ||
      (c.usuario_nome || '').toLowerCase().includes(buscaLower) ||
      (c.usuario_email || '').toLowerCase().includes(buscaLower) ||
      (c.ip || '').toLowerCase().includes(buscaLower)
    );
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />
      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🛡️ Auditoria de Comandos</span>
        </div>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>
        <div style={{ background: 'white', borderRadius: '12px', padding: '16px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input placeholder="🔍 Buscar por veículo, usuário ou IP..." value={busca} onChange={e => setBusca(e.target.value)}
            style={{ flex: '1 1 260px', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' }} />
          <select value={tipo} onChange={e => setTipo(e.target.value)}
            style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', background: 'white' }}>
            <option value="">Todas as ações</option>
            <option value="BLOQUEAR">🔒 Bloquear</option>
            <option value="DESBLOQUEAR">🔓 Desbloquear</option>
          </select>
          <label style={{ fontSize: '12px', color: '#666' }}>De: <input type="date" value={inicio} onChange={e => setInicio(e.target.value)}
            style={{ padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', marginLeft: '4px' }} /></label>
          <label style={{ fontSize: '12px', color: '#666' }}>Até: <input type="date" value={fim} onChange={e => setFim(e.target.value)}
            style={{ padding: '8px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', marginLeft: '4px' }} /></label>
          {busca && <span style={{ fontSize: '12px', color: '#999', whiteSpace: 'nowrap' }}>{comandosFiltrados.length} resultado{comandosFiltrados.length !== 1 ? 's' : ''}</span>}
          <button onClick={() => exportarAuditoriaPDF(comandosFiltrados)} style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📄 Exportar PDF</button>
          <button onClick={() => exportarAuditoriaCSV(comandosFiltrados)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '8px', padding: '10px 16px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap' }}>📥 Exportar Excel</button>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f8f8f8' }}>
              <tr>{['Data/Hora', 'Veículo', 'Ação', 'Usuário', 'IP', 'Status'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="6" style={{ padding: '32px', textAlign: 'center', color: '#999' }}>⏳ Carregando...</td></tr>
              ) : comandosFiltrados.length === 0 ? (
                <tr><td colSpan="6" style={{ padding: '32px', textAlign: 'center', color: '#999' }}>Nenhum comando encontrado.</td></tr>
              ) : comandosFiltrados.map((c, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                  <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>{c.criado_em ? new Date(c.criado_em).toLocaleString('pt-BR') : '—'}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px' }}>
                    <div style={{ fontWeight: '700', fontFamily: 'monospace' }}>{c.target_identificador || '—'}</div>
                    <div style={{ fontSize: '11px', color: '#999' }}>{c.target_nome}</div>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    {c.tipo === 'BLOQUEAR' ? (
                      <span style={{ background: '#FCEBEB', color: '#A32D2D', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600' }}>🔒 Bloquear</span>
                    ) : (
                      <span style={{ background: '#E1F5EE', color: '#0F6E56', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600' }}>🔓 Desbloquear</span>
                    )}
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '13px' }}>
                    <div>{c.usuario_nome || '—'}</div>
                    <div style={{ fontSize: '11px', color: '#999' }}>{c.usuario_email || ''}</div>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666', fontFamily: 'monospace' }}>{c.ip || '—'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      background: c.status === 'enviado' ? '#E1F5EE' : '#FAEEDA',
                      color: c.status === 'enviado' ? '#0F6E56' : '#633806',
                      padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500'
                    }}>{c.status === 'enviado' ? '✅ Enviado' : '⏳ Pendente'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Auditoria;
